import { Typography } from 'antd';
import React from 'react';

const Get = () => {
  return (
    <Typography.Text type='success' style={{ marginRight: '8px' }}>
      GET
    </Typography.Text>
  );
};

export default Get;
